var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13-copy",
    transform: "translate(-1369.000000, -86.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(1369.144435, 86.040896)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "0.000320133111 2.2594 2.26446156 0.000159776537 19.2419208 16.9468581 16.9777794 19.2068972"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "2.26414143 19.2067374 0 16.9466983 16.9782596 0 19.2416007 2.25924022"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f91073f3db71a24bd9de3e0e63d2b58b.svg";
export { ForwardRef as ReactComponent };